<template>
  <div class="index_main">
    <div class="topPart">
      <div class="left">
        <div class="title">
          <div class="line"></div>Dicom影像数量统计
        </div>
        <div ref="myEchart" class=""></div>
        <div ref="echart2" style="height: 80%;"></div>
        <div class="countBox">
          <div class="singleBox">
            <div class="tit">检查总数</div>
            <div class="count"><span class="special">{{ echartsDicom.sum }}</span>个</div>
            <div class="tendency" :class="AStatus? 'tendencyUp' : ''">&nbsp{{ echartsDicom.a }}</div>
          </div>
          <div class="singleBox">
            <div class="tit">非Dicom数量</div>
           
            <div class="count"><span class="special">{{ echartsDicom.daydicomCount}}</span>个</div>
            <div class="tendency" :class="BStatus ? 'tendencyUp' : ''">&nbsp{{ echartsDicom.b||0 }}</div>

          </div>
          <div class="singleBox">
            <div class="tit">运行服务监控</div>
            <div class="count"><span class="special">{{  echartsDicom.servicetotal2 }}</span>个</div>
            <div class="tendency" :class="CStatus ? 'tendencyUp' : ''">&nbsp{{ echartsDicom.c||0 }}
            </div>

          </div>
        </div>
      </div>
      <div class="right">
        <div class="rightBox" style="margin-bottom: 16px;">
          <div class="title">
            <div class="line"></div>患者数量
          </div>
          <div ref="echart1" style="height:100%;"></div>
        </div>
        <div class="rightBox">
          <div class="title">
            <div class="line"></div>影像存储累计大小
          </div>
          <div style="display: flex;">
            <div class="right_left" ref="echart3" style="width: 55%;"></div>
            <div class="right_right" style="width: 46%;">
              <div class="top">
                {{ 
                  (parseFloat(userSize / totalSize*100)).toFixed(2)
                  }}%
              </div>
              <div class="bottom">
                <div class="bottom_bottom">
                  <div style="background-color:#338bff;"></div>
                  <p>使用量:{{ userSize }} GB</p>
                </div>
                <div class="bottom_bottom">
                  <div style="background-color:#b4d4ff;"></div>
                  <p>未使用量:{{ totalSize- userSize }} GB</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottomPart">
      <div class="left">
        <div class="title">
          <div class="line"></div>接入机构列表
        </div>
        <scrollView :dataList="echartData"></scrollView>
      </div>
      <div class="right">
        <div class="title">
          <div class="line"></div>帮助中心
        </div>
        <div class="helpBox">
          <div class="singleHelp">
            <img src="../../assets/statistics_image/help1.png" />
            <div>初始化教程</div>
          </div>
          <div class="singleHelp">
            <img src="../../assets/statistics_image/help3.png" />
            <div>数据采集配置教程</div>
          </div>
          <div class="singleHelp">
            <img src="../../assets/statistics_image/help4.png" />
            <div>数据校对教程</div>
          </div>
          <div class="singleHelp">
            <img src="../../assets/statistics_image/help2.png" />
            <div>其他教程</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import scrollView from '../../components/DataFormScrool.vue'
import echarts from 'echarts'
import token from "../../utils/token.js";
let echart1, echart2, echart3
export default {
  computed:{
    AStatus(){
      if(this.echartsDicom.a){
        return this.echartsDicom.a[0] == '+'
      }
    },
    BStatus(){
     if (this.echartsDicom.b) {
        return this.echartsDicom.b[0] == '+'
      }
    },
    CStatus(){
      if (this.echartsDicom.b) {
        return this.echartsDicom.b[0] == '+'
      }
    }

  },

  data() {
    return {
      echartData:[
      
       
      ],
      userSize:0,
      totalSize:0,
      myChart: null,
      formData: {
        organCodeSum: 0,
        userCodeSum: 0,
        clientSN: 0,
        examTypeName: 0,
        examBodyName: 0,
        examitemName: 0,
        imageIDSum: 0,
        imageNodcmID: 0,
        imageSumb: 0
      },
      cpu_data: 0,
      diskUsage: 0,
      echarts_data: [],
      echartsDicom: {},
      patientsNum:{},
      barDate: [],
      dataList: []
    };
  },
  components: {
    scrollView: scrollView
  },
  created() {
    this.getDicomData()
    this.getInitCount()
    this.getHospital()
    this.echartThree()
  },
  mounted() {
    window.addEventListener("resize", () => {
      echart1.resize()
      echart2.resize()
      echart3.resize()
    })
    this.cpu_web()
    this.getDiskUseAndFree()
    // this.$nextTick(() => {

    //   this.echartsInitWeb2()

    // })
  },
  methods: {
    echartThree(){
      this.$api.get('/HomePage/DiskUseAndFree').then((res)=>{
        res.data.forEach((item)=>{
          console.log(item.totalSize);
          console.log(item.userSize);
            this.totalSize= this.totalSize+parseInt(item.totalSize)
            this.userSize=this.userSize+parseInt(item.userSize)
        })
      })
    },
    echartsInit() {
      echart1 = echarts.init(this.$refs.echart1)
      let option1 = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          top: '5%',
          left: '3%',
          right: '10%',
          bottom: '10%',
          // containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: this.patientsNum.patientMonth ,
            axisTick: {
              show: false,
              alignWithLabel: true
            },
            axisLine: {
              show: false
            }
          }
        ],
        yAxis: [
          {
            position: 'right',
            type: 'value',
            axisTick: {
              show: false,
              alignWithLabel: true
            },
            axisLine: {
              show: false
            }

          },

        ],
        series: [
          {
            name: 'Direct',
            type: 'bar',
            barWidth: '60%',
            data: this.patientsNum.patientCount,
            itemStyle: {
              color: '#BAD3FB',
              barBorderRadius: 5
            }
          }
        ]
      };
      echart1.setOption(option1)
      echart2 = echarts.init(this.$refs.echart2)
      let option2 = {
        xAxis: {
          type: 'category',
          data:this.echartsDicom.x,

          axisTick: {
            show: false,
          },
          axisLine: {
            show: false
          }
        },
        yAxis: {
          position: 'right',
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false
          }
        },
        series: [
          {
            data: this.echartsDicom.y,
            type: 'line',
            smooth: 'true',
            symbol: 'circle',
            symbolSize: '8',
            color: '#338BFF',
            itemStyle: {
              color: "#338BFF",
              normal: {
                color: "#338BFF",
                shadowColor: 'rgba(23, 69, 129, 0.32)',
                shadowBlur: 2,
                borderWidth: 2, // 设置边框宽度  
                borderColor: "#fff", // 设置边框颜色  
                borderRadius: 4 // 设置边框圆角  

              }
            }
          },
        ]
      };
      echart2.setOption(option2)
      echart3 = echarts.init(this.$refs.echart3)
      let option3 = {
        legend: {
          left: 'center',
          top: 'bottom',
          data: [
            'rose7',
            'rose8'
          ]
        },
        toolbox: {
          show: true,
        },
        color: ['#338BFF', '#B4D4FF'],
        series: [
          {
            name: 'Radius Mode',
            type: 'pie',
            radius: [20, 65],
            center: ['50%', '50%'],
            // roseType: 'radius',
            itemStyle: {
              borderRadius: 5,

            },
            label: {
              show: false
            },
            data: [
              { value: (this.userSize), name: 'rose 8' },
              { value: this.totalSize - this.userSize, name: 'rose 7' },
            ]
          },

        ]
      };
      echart3.setOption(option3)
    },
    //
    getDicomData() {
      //Dicom影像数量统计
      this.$api.get('/HomePage/GetImageDicom').then((res) => {
        if (res.statusCode == 200) {
          console.log(res.data);
          this.echartsDicom = res.data
          // this.echartsDicom.x= JSON.parse(this.echartsDicom.x)
          this.echartsInit()
          console.log('*-----------',this.echartsDicom);
        }
      })
    },
    getInitCount() {
      //  //患者数量
      this.$api.get('/HomePage/GetPatientCount').then((res) => {
        if (res.statusCode == 200) {
          console.log(res.data);
          this.patientsNum = res.data
          this.echartsInit()
        }
      })
      // 挂靠机构
      // this.$api.get("/HomePage/GetOrganCodeCount").then((rsp) => {
      //   if (rsp != false) {
      //     this.formData.organCodeSum = rsp.data
      //   }
      // });
      // 医生数量
      // this.$api.get("/HomePage/GetUserInfoCount").then((rsp) => {
      //   if (rsp != false) {
      //     this.formData.userCodeSum = rsp.data
      //   }
      // });
      // 检查设备
      // this.$api.get("/HomePage/GetClientinfoCount").then((rsp) => {
      //   if (rsp != false) {
      //     this.formData.clientSN = rsp.data
      //   }
      // });
      // 检查类型
      // this.$api.get("/HomePage/GetExamTypeNameCount").then((rsp) => {
      //   if (rsp != false) {
      //     this.formData.examTypeName = rsp.data
      //   }
      // });
      // 检查部位
      // this.$api.get("/HomePage/GetExamBodyNameCount").then((rsp) => {
      //   if (rsp != false) {
      //     this.formData.examBodyName = rsp.data
      //   }
      // });
      // 检查项目
      // this.$api.get("/HomePage/GetExamitemNameCount").then((rsp) => {
      //   if (rsp != false) {
      //     this.formData.examitemName = rsp.data
      //   }
      // });
      // dicom影像量
      // this.$api.get("/HomePage/GetImageIDCount").then((rsp) => {
      //   if (rsp != false) {
      //     this.formData.imageIDSum = rsp.data
      //   }
      // });
      // 非dicom影像量
      // this.$api.get("/HomePage/GetImageNodcmIDCount").then((rsp) => {
      //   if (rsp != false) {
      //     this.formData.imageIDSum = rsp.data
      //   }
      // });
      // dicom影像量
      // this.$api.get("/HomePage/GetImageIDCount").then((rsp) => {
      //   if (rsp != false) {
      //     this.formData.imageNodcmID = rsp.data
      //   }
      // });
      // 影像数据累计大小
      // this.$api.get("/HomePage/GetImageSize").then((rsp) => {
      //   if (rsp != false) {
      //     this.formData.imageSumb = rsp.data.toFixed(0)
      //   }
      // });

    },
        getHospital() {
      //Dicom影像数量统计
      this.$api.get('/HomePage/GetOrgInfo').then((res) => {
        if (res.statusCode == 200) {
          console.log(res.data);
          this.echartData = res.data
          // this.echartsDicom.x= JSON.parse(this.echartsDicom.x)
          this.echartsInit()
          console.log('*-----------', this.echartsDicom);
        }
      })
    },
    // 检查数量
    GetStudvinfoCount() {
      this.$api.get("/HomePage/GetStudvinfoCount", {
        organCode: window.sessionStorage.getItem('organCode')
      }).then((rsp) => {
        if (rsp != false) {
          //  this.cpu_data = rsp.data;
          console.log('拿到检查数量', rsp);
        }
      });
    },
    // 磁盘剩余量
    getDiskUseAndFree() {
      this.$api.get("/HomePage/DiskUseAndFree").then((rsp) => {
        if (rsp != false) {
          try {
            let userSize = 0
            let totalSize = 0
            rsp.data.forEach(item => {
              userSize += Number(item.userSize * 1000)
              totalSize += Number(item.totalSize * 1000)
            })
            this.diskUsage = ((userSize / 1000) / (totalSize / 1000) * 100).toFixed(2)
          } catch {
            this.diskUsage = 0
          }
        }
      });
    },
    cpu_web() {
      // cpu数据
      this.$api.get("/HomePage/CpuLoad").then((rsp) => {
        if (rsp != false) {
          this.cpu_data = rsp.data;
          // console.log('拿到cpu',this.cpu_data);
        }
      });
    },

    // 请求echert数据
    echartsInit_web() {
      this.$api.get("/HomePage/NamebyCount").then((rsp) => {
        if (rsp != false) {
          this.echarts_data = rsp.data;
          // console.log('拿到echert数据',this.echarts_data);
          for (var i = 0; i < this.echarts_data.length; i++) {
            // console.log('每一项',this.echarts_data[i].organName);
            this.barDate.push(this.echarts_data[i].organName)
            this.dataList.push(this.echarts_data[i].imageCount)
          }
          // console.log('123',this.barDate,this.dataList);
          this.initChart()
          // this.myChart.setOption({
          //   xAxis:{
          //     data:this.barDate
          //   },
          //   series:[
          //     {
          //       data:this.dataList
          //     }
          //   ]

          // })
        }
      });
    },
    echartsInitWeb2() {
      this.$api.get("/HomePage/GetStatisticalImageinfo").then((rsp) => {
        console.log(rsp)
        if (rsp.data) {
          this.barDate = rsp.data.x
          this.dataList = rsp.data.y
          // this.barDate=JSON.parse(rsp.data.x)
          // this.dataList=JSON.parse(rsp.data.y)
          this.initChart()
        }
      })
    },
    initChart() {
      // this.myChart = echarts.init(this.$refs.myEchart)
      // let options = {
      //   tooltip: {
      //     trigger: 'axis',
      //     axisPointer: {
      //       type: 'shadow'
      //     }
      //   },
      //   grid: {
      //     top: '8%',
      //     right: '5%',
      //     left: '10%',
      //     bottom: '8%'
      //   },
      //   xAxis: {
      //     type: 'category',
      //     // data: ['dfg'],
      //     data: this.barDate.map(item => item.slice(5)),
      //     axisLine: {
      //       lineStyle: {
      //         color: '#E8E8E8'
      //       }
      //     },
      //     axisLabel: {
      //       margin: 10,
      //       color: '#333',
      //       textStyle: {
      //         fontSize: 14
      //       },
      //     },
      //     axisTick: {
      //       show: false,
      //     },
      //   },
      //   yAxis: {
      //     splitNumber: 3,
      //     axisLabel: {
      //       formatter: '{value}',
      //       color: '#333',
      //     },
      //     axisLine: {
      //       show: true,
      //       lineStyle: {
      //         color: '#E8E8E8'
      //       }
      //     },
      //     axisTick: {
      //       show: false,
      //     },
      //     splitLine: {
      //       // show: false,
      //       lineStyle: {
      //         color: '#E8E8E8'
      //       }
      //     },
      //   },
      //   // [['#FDA164','#ED4D5D'],['#FECE57','#F8843E'],['#3DD8E0','#3B66F7'],['#89D175','#1EB5AC'],['#DAC3F9','#B786FA'],['#A2FAFA','#3DEEEB']]
      //   series: [{
      //     type: 'bar',
      //     data: this.dataList.map((item, index) => {
      //       return {
      //         value: item,
      //         itemStyle: {
      //           color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      //             offset: 0,
      //             color: '#89D175' // 0% 处的颜色
      //           }, {
      //             offset: 1,
      //             color: '#1EB5AC' // 100% 处的颜色
      //           }], false),
      //           barBorderRadius: [30, 30, 30, 30],
      //         }
      //       }
      //     }),
      //     barWidth: '15px',
      //     // itemStyle: {
      //     //     normal: {
      //     //         color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      //     //             offset: 0,
      //     //             color: '#FDA164' // 0% 处的颜色
      //     //         }, {
      //     //             offset: 1,
      //     //             color: '#ED4D5D' // 100% 处的颜色
      //     //         }], false),
      //     //         barBorderRadius: [30, 30, 30, 30],
      //     //     }
      //     // },
      //   }]
      // }

      // this.myChart.setOption(options)
    }
  }
};
</script>
<style scoped lang="scss">
.index_main {
  padding-left: 15rem;
  padding-top: calc(4.5rem + 40px);
  padding-right: 1rem;

  .title {
    display: flex;
    text-indent: 8px;
    font-size: 18px;
    font-weight: 600;
    color: #333333;

    .line {
      width: 4px;
      height: 18px;
      background: #338BFF;
      margin: 4px 0 0 0;
    }
  }

  .topPart {
    display: flex;

    .left {
      width: 65%;
      height: 480px;
      background: #FFFFFF;
      border-radius: 20px;
      padding: 24px;

      .countBox {
        display: flex;
        justify-content: space-around;

        .singleBox {
          position: relative;
          text-align: center;

          .tendency {
            position: absolute;
            display: flex;
            right: -30px;
            top: 35%;
            // background-color: red;
            color: green;
            width: 30px;
            // height:30px;
            font-size: 12px;
          }

          .tendency::before {
            content: "";
            height: 0;
            width: 0;
            margin-top: 5px;
            display: inline-block;
            border: 4px solid transparent;
            border-top: 5px solid green;

          }

          .tendencyUp {
            color: red;
          }

          .tendencyUp::before {
            content: "";
            margin: 0;
            height: 0;
            width: 0;
            display: inline-block;
            border: 4px solid transparent;
            border-bottom: 5px solid red;

          }

          .tit {
            font-size: 16px;
            font-weight: 500;
            color: #666666;

          }

          .count {

            font-size: 14px;
            font-weight: 400;
            color: #333333;

            .special {
              font-size: 48px;
              font-weight: bold;
            }
          }
        }
      }
    }

    .right {
      margin-left: 16px;
      width: 33%;

      .rightBox {
        height: 232px;
        background: #FFFFFF;
        border-radius: 20px;
        padding: 24px;

        .right_left {
          height: 180px;
          width: 60%;
        }

        .right_right {
          padding: 15px 0;
          cursor: default;
          user-select: none;

          .top {
            // font-family: "DIN Alternate-Bold", "DIN Alternate";
            color: #333333;
            font-weight: bold;
            font-size: 64px;
            letter-spacing: -2px;

          }

          .bottom {

            // .bottom_top {
            //   height: 40px;
            //   div {
            //     // flex;
            //     display: inline-block;
            //     width: 18px;
            //     height: 18px;
            //     background-color: #338bff;
            //     // margin-bottom: 11px;
            //     margin-right: 5px;
            //   }
            //   p{
            //     font-size: 16px;
            //     display: inline-block;
            //   }
            // }
            .bottom_bottom {
              height: 40px;

              div {
                margin-top: 2px;
                border-radius: 5px;
                box-sizing: border-box;
                margin-right: 5px;
                display: inline-block;
                width: 18px;
                height: 18px;
              }

              p {
                vertical-align: top;
                font-size: 16px;
                display: inline-block;
              }
            }
          }
        }
      }
    }
  }

  .bottomPart {
    display: flex;

    .left {
      width: 65%;
      height: 329px;
      background: #FFFFFF;
      border-radius: 20px;
      padding: 24px;
      margin: 16px 0 0 0;
    }

    .right {
      width: 33%;
      height: 329px;
      background: #FFFFFF;
      border-radius: 20px;
      padding: 24px;
      margin: 16px 0 0 16px;

      .helpBox {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .singleHelp {
          cursor: pointer;
          user-select: none;
          width: 135px;
          height: 112px;
          border-radius: 10px 10px 10px 10px;
          border: 1px solid #E5E5E5;
          margin: 16px 0 0 0;
          text-align: center;
          font-size: 16px;
          font-weight: 400;
          color: #333333;

          img {
            margin: 24px auto 16px;
          }
        }
      }
    }
  }
}
</style>